export enum Role {
  ADMIN = 'admin',
  ADMIN_SITE = 'adminSite',
  USER = 'user',
  SUPER_ADMIN = 'superAdmin',
  EDITOR = 'editor',
  VIEWER = 'viewer',
  OPERATOR = 'operator',
  OPERATOR_RESTRICTED = 'operatorRestricted',
  MANAGER = 'manager',
}
